import React from "react";

/**
 * @param {*} props
 * @param {string} props.styleName
 */
export default class Fa extends React.Component {
  render() {
    return (
      <React.Fragment>
        <span className={`fa fa-${this.props.icon}`} />
        &nbsp;
      </React.Fragment>
    );
  }
}
